<template>
  <div id="orderInfo">
    <div class="steps">
      <div class="step-item">
        <i class="iconfont icon-tishichenggong big-icon finish"></i>
        <div>用户下单</div>
      </div>
      <div class="link-line"></div>
      <div class="step-item">
        <i v-if="status == 6" class="iconfont error-icon icon-cuowu" style="color:red"></i>
        <i
          v-else
          class="iconfont big-icon"
          :class="status > 2?'icon-tishichenggong finish':'icon-dengdai wait'"
        ></i>
        <div>商家发货</div>
      </div>
      <div class="link-line" :class="status <= 2?'check-link-line':''"></div>
      <div class="step-item">
        <i v-if="status == 6" class="iconfont error-icon icon-cuowu" style="color:red"></i>
        <i
          v-else
          class="iconfont big-icon"
          :class="status > 3?'icon-tishichenggong finish':'icon-dengdai wait'"
        ></i>
        <div>用户收货</div>
      </div>
      <div class="link-line" :class="status <= 3?'check-link-line':''"></div>
      <div class="step-item">
        <i v-if="status == 6" class="iconfont error-icon icon-cuowu" style="color:red"></i>
        <i
          v-else
          class="iconfont i big-icon"
          :class="status > 4?'icon-tishichenggong finish':'icon-dengdai wait'"
        ></i>
        <div>用户评价</div>
      </div>
      <div class="link-line" :class="status <= 4?'check-link-line':''"></div>
      <div class="step-item">
        <i v-if="status == 6" class="iconfont error-icon icon-cuowu" style="color:red"></i>
        <i
          v-else
          class="iconfont big-icon"
          :class="status == 5?'icon-tishichenggong finish':'icon-dengdai wait'"
        ></i>
        <div>交易完成</div>
      </div>
      <div class="link-line" :class="status <= 5?'check-link-line':''"></div>
      <div class="step-item">
        <i
          class="iconfont big-icon"
          :class="status == 6?'icon-tishichenggong finish':'icon-dengdai wait'"
        ></i>
        <div>取消交易</div>
      </div>
    </div>
    <div class="table-header-box">
      <div class="now-status">
        <i class="iconfont icon-tanhao"></i> 当前订单状态 :
        <span v-if="status == 0">待付款</span>
        <span v-else-if="status == 1 || status == 2">待发货</span>
        <span v-else-if="status == 3">待收货</span>
        <span v-else-if="status == 4">待评价</span>
        <span v-else-if="status == 5">已完成</span>
        <span v-else-if="status == 6">已取消</span>
      </div>
    </div>
    <div class="table-box">
      <div class="info">
        <div>
          <i class="iconfont icon-icon_favorite" style="color:#999999"></i> 基本信息
        </div>
        <table class="table">
          <tr>
            <th>订单编号</th>
            <th>用户账号</th>
            <th>支付方式</th>
            <th>订单来源</th>
            <th>订单类型</th>
            <th>物流单号</th>
            <th>物流公司</th>
          </tr>
          <tr>
            <td>{{info.orderCode}}</td>
            <td>{{info.mobile}}</td>
            <td>{{info.pay_type == 2?'账期支付':'在线支付'}}</td>
            <td>PC客户</td>
            <td>{{info.order_type == 0?'普通订单':''}}</td>
            <td>{{express.code}}</td>
            <td>{{express.com}}</td>
          </tr>
        </table>
      </div>
      <div class="info" v-show="this.invoice">
        <div>
          <i class="iconfont icon-icon_favorite" style="color:#999999"></i>发票信息
        </div>
        <table class="table">
          <tr>
            <th>发票类型</th>
            <th>抬头名称</th>
            <!-- <th>发票抬头</th> -->
            <th v-show="invoice.tax_number">纳税人识别号</th>
            <th>开票内容</th>
            <th>收票人姓名</th>
            <th>收票人电话</th>
            <th>收票人地址</th>
          </tr>
          <tr>
            <td>{{invoice.type==1?'普通发票':'增值税发票'}}/{{invoice.type2==1?'个人':'单位'}}</td>
            <td>{{invoice.name}}</td>
            <!-- <td>{{invoice.invoice_name}}</td> -->
            <td v-show="invoice.tax_number">{{invoice.tax_number}}</td>
            <td>{{invoice.content}}</td>
            <td>{{invoice.invoice_name}}</td>
            <td>{{invoice.invoice_mobile}}</td>
            <td>{{invoice.address}}</td>
          </tr>
        </table>
      </div>
      <div class="info">
        <div>
          <i class="iconfont icon-icon_favorite" style="color:#999999"></i>收货人信息
        </div>
        <table class="table">
          <tr>
            <th>收货人姓名</th>
            <th>收货人电话</th>
            <th>收货人地址</th>
          </tr>
          <tr>
            <td>{{address[1]}}</td>
            <td>{{address[0]}}</td>
            <td style="max-width:200px">{{address[2]}}{{address[3]}}{{address[4]}}{{address[5]}}</td>
          </tr>
        </table>
      </div>
      <div class="info">
        <div>
          <i class="iconfont icon-icon_favorite" style="color:#999999"></i>商品信息
        </div>
        <table class="table">
          <tr>
            <th>商品名称</th>
            <th>商品货号</th>
            <th>商品价格</th>
            <th>账期价格</th>
            <th>商品数量</th>
            <th>合计</th>
          </tr>
          <tr v-for="(item,index) in productData" :key="index">
            <td style="max-width:200px">{{item.title}}</td>
            <td>{{item.item_no}}</td>
            <td>{{item.selling_price?item.selling_price:item.price}}</td>
            <td>{{item.selling_price?item.price:'在线支付'}}</td>
            <td>{{item.number}}</td>
            <td>{{item.price * item.number}}</td>
          </tr>
        </table>
      </div>
      <div class="info">
        <div>
          <i class="iconfont icon-icon_favorite" style="color:#999999"></i>费用信息
        </div>
        <table class="table">
          <tr>
            <th>商品金额</th>
            <th>运费</th>
            <th>应付金额</th>
            <th>回款方式</th>
            <th>回款状态</th>
          </tr>
          <tr>
            <td>{{info.pay_money}}</td>
            <td>{{info.express_money}}</td>
            <td>{{info.pay_money}}</td>
            <td v-if="info.shop_pay_status ==4">其他</td>
            <td v-else-if="info.shop_pay_status ==1">微信</td>
            <td v-else-if="info.shop_pay_status ==2">支付宝</td>
            <td v-else-if="info.shop_pay_status ==3">银行卡</td>
            <td v-else>未支付</td>
            
            <td>{{info.pay_status == 1 ? '已付款' : '未付款'}}</td>
          </tr>
        </table>
      </div>
      <div class="bottom-button">
        <el-button type="primary" @click="showShipment = true" v-show=" 0 < status && status < 3">确认发货</el-button>
      </div>
    </div>
    <div>
      <el-dialog title="发货信息" :visible.sync="showShipment" width="800px">
        <el-form :model="shipmentForm">
          <el-form-item label="快递单号 :" label-width="100px">
            <el-input v-model="shipmentForm.expressCode" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="快递公司 :" label-width="100px">
            <el-select v-model="shipmentForm.expressCom" placeholder="请选择快递公司">
              <el-option
                v-for="item in expressList"
                :key="item.id"
                :label="item.com_name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="showShipment = false">取 消</el-button>
          <el-button type="primary" @click="submitShipment">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      serve: this.$store.state.serve,
      token: this.$cookies.get('shop_token'),
      address: [],
      invoice: [],
      info: {},
      productData: {},
      id: this.$route.params.id,
      status: '',
      express: '',
      expressList: [],
      showShipment: false,
      shipmentForm: {}
    }
  },
  created() {
    this.$store.state.shop_top = 2;
    this.$store.state.shop_left = "订单列表";
    this.getInfo()
    this.getExpressList()
  },
  methods: {
    submitShipment(){
        var where = this.shipmentForm
        if (!where.expressCode) {
            this.$alerts.error('订单编号为必填选项',this.$message)
            return;
        }
        if (!where.expressCom) {
            this.$alerts.error('快递公司为必填选项',this.$message)
            return;
        }
        where.token = this.token
        where.orderId = this.id
        this.axios 
        .get(this.serve + 'shop/shipments',{params : where }).then(res=>{
            var data = res.data
          if (data.status == 'success') {
            this.$alerts.success('发货成功',this.$message)
            this.showShipment = false;
            this.expressForm = {}
            this.getInfo();
          } else {
            this.$alerts.error('发货失败,检查信息后重新发货',this.$message)
          }
          
        })
    },
    getExpressList() {
      var where = {
        token: this.token
      }
      this.axios
        .get(this.serve + 'shop/getExpressList', { params: where })
        .then(res => {
          var data = res.data
          if (data.status == 'success') {
            this.expressList = data.data.results
          } else {
            this.expressList = []
          }
        })
    },
    getInfo() {
      var where = {
        token: this.token,
        order_id: this.id
      }
      this.axios
        .get(this.serve + 'shop/orderInfo', { params: where })
        .then(res => {
          var data = res.data
          if (data.status == 'success') {
            this.info = data.data
            this.address = data.data.address.split(';')
            this.invoice = data.data.invoice
            this.productData = data.data.product_list
            this.status = data.data.status
            if (typeof data.data.express == 'string') {
              this.express = {
                code: '订单暂未发货',
                com: '订单暂未发货'
              }
            } else {
              this.express = {
                code: data.data.express.express_code,
                com: data.data.express.express_com
              }
            }
          }
        })
    }
  }
}
</script>
<style lang="scss">
#orderInfo {
  font-size: 14px;
  .steps {
    display: flex;
    justify-content: space-between;
    padding-left: 127px;
    padding-right: 127px;
    .link-line {
      margin-top: 32px;
      height: 3px;
      width: 120px;
      background-color: #0099ff;
    }
    .check-link-line {
      background-color: #cccccc;
    }
    .big-icon {
      font-size: 60px;
    }
    .error-icon {
      font-size: 60px;
    }
    .finish {
      color: #0099ff;
    }
    .now {
      color: rgba(246, 78, 98, 1);
    }
    .wait {
      color: #cccccc;
    }
  }
  .table-header-box {
    margin-top: 41px;
    width: 1060px;
    height: 80px;
    background: rgba(238, 238, 238, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    display: flex;
    align-items: center;
    .now-status {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: rgba(246, 78, 98, 1);
      margin-left: 21px;
    }
  }
  .table-box {
    width: 1060px;
    min-height: 900px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    margin-bottom: 116px;
    .info {
      margin: 40px 21px 0 21px;
      .table {
        width: 1020px;
        text-align: center;
        margin-top: 14px;
        th {
          text-align: center;
          background: rgba(245, 250, 249, 1);
          height: 40px;
          border: 1px solid rgba(221, 221, 221, 1);
        }
        td {
          border: 1px solid rgba(221, 221, 221, 1);
          height: 58px;
        }
      }
    }
    .bottom-button {
      padding: 20px;
      display: flex;
      justify-content: flex-end;
    }
  }
}
</style>